import React, { FC, PropsWithChildren } from 'react';
import { PaperProps } from '@mui/material/Paper';
import { Card as MuiCard, Stack, SxProps, Theme } from '@mui/material';

interface CardProps extends PaperProps { sx?: SxProps<Theme> }

const Card: FC<PropsWithChildren<CardProps>> = ({ sx = [], children, ...props }) => (
  <MuiCard
    {...props}
    sx={[
      {
        boxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.25);',
        borderRadius: '10px',
        padding: '15px'
      },
      ...(Array.isArray(sx) ? sx : [sx])
    ]}>
    <Stack direction="column">
      {children}
    </Stack>
  </MuiCard>
);

export default Card;
